import React, { useEffect } from "react";
import { API } from 'aws-amplify';
import ChatBox from "./components/ChatBox";

const ChatWidgetComponent = () => {
  const agentInfo = {
    id: "asst_rLdYA65mTaYaSrbRzLiMBlmj&customer=8mxc5kr8",
    customer_id: "iv6wyozw",
    name: "Ann Brooks",
    role: "",
    avatar: "https://dealerlakes.s3.amazonaws.com/ford-avatar.png",
    systemPrompt: `You are a virtual assistant specialized in data analysis.`
  };

  useEffect(() => {
    // Configure API to use IAM authentication
    API.configure({
      aws_appsync_authenticationType: 'AWS_IAM'
    });
  }, []);

  return (
    <ChatBox
      agentName={agentInfo.name}
      agentRole={agentInfo.role}
      agentAvatar={agentInfo.avatar}
      agentId={agentInfo.id}
      customerId={agentInfo.customer_id}
      systemPrompt={agentInfo.systemPrompt}
    />
  );
};

export default ChatWidgetComponent;
